/* ==========================================================================
   assets/armonia-search.js — ricerca Armonia
   - desktop: la lente apre la barra al posto del menu (X o Esc per chiudere)
   - da 3 lettere in poi mostra la tendina con i primi 10 prodotti (HTML da
     sections/armonia-predictive-search.liquid, quindi prezzi formattati da Liquid)
   - barra intelligente: brand, colore e taglia riconosciuti nel testo diventano
     pillole e, premendo Invio, filtri esatti nella pagina risultati
   - tastiera: frecce su/giù tra i risultati, Invio apre, Esc chiude
   ========================================================================== */
(function () {
  'use strict';

  var A = (window.Armonia = window.Armonia || {});

  function track(name, params) {
    try {
      if (A.track) { A.track(name, params || {}); return; }
      if (typeof window.armoniaTrack === 'function') { window.armoniaTrack(name, params || {}); return; }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch (e) { /* il tracking non deve mai rompere la ricerca */ }
  }

  /* Normalizza per il confronto: minuscolo, senza accenti, senza punteggiatura. */
  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^0-9a-z\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function words(s) {
    var t = norm(s);
    return t ? t.split(' ') : [];
  }

  /* ---------- Dizionari ----------
     Ogni impostazione è testo semplice, una riga per voce: «Etichetta: parola, parola».
     - le parole riconosciute nel testo digitato sono l'etichetta più tutte le parole della riga
     - i valori mandati al filtro sono gli stessi, in OR fra loro, con l'aggiunta della versione
       tutta minuscola: così «Vicolo» e «vicolo», «Maglia» e «maglia» vengono presi entrambi
       anche se nel catalogo sono scritti in due modi.
     Ogni voce: { kind, label, param, values: [...], forms: [[parola, parola], ...] } */
  function parseLines(raw) {
    var out = [];
    (raw || '').split('\n').forEach(function (line) {
      var l = line.trim();
      if (!l) return;
      var i = l.indexOf(':');
      var label = (i < 0 ? l : l.slice(0, i)).trim();
      if (!label) return;
      var rest = i < 0 ? '' : l.slice(i + 1);
      var ws = rest.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      out.push({ label: label, words: ws });
    });
    return out;
  }

  function entry(kind, param, label, ws) {
    var raw = [label].concat(ws);
    var values = [];
    raw.forEach(function (v) {
      [v, v.toLowerCase()].forEach(function (x) {
        if (x && values.indexOf(x) === -1) values.push(x);
      });
    });
    var forms = [];
    raw.forEach(function (v) {
      var w = words(v);
      if (w.length && !forms.some(function (f) { return f.join(' ') === w.join(' '); })) forms.push(w);
    });
    forms.sort(function (a, b) { return b.length - a.length; });
    return { kind: kind, label: label, param: param, values: values, forms: forms };
  }

  function buildDict(el) {
    var out = [];
    [
      ['brand', 'data-brands', 'data-brand-param'],
      ['type', 'data-types', 'data-type-param'],
      ['color', 'data-colors', 'data-color-param'],
      ['size', 'data-sizes', 'data-size-param']
    ].forEach(function (cfg) {
      var param = el.getAttribute(cfg[2]);
      parseLines(el.getAttribute(cfg[1])).forEach(function (e) {
        out.push(entry(cfg[0], param, e.label, e.words));
      });
    });
    return out;
  }

  /* Parole che il cliente scrive per spiegarsi ma che non sono mai nel nome di un capo:
     tolte dal testo cercato, altrimenti con l'AND di Shopify stringono i risultati a caso. */
  var FILLER = ['taglia', 'taglie', 'misura', 'colore', 'color', 'brand', 'marca', 'modello'];

  /* Trova nel testo le voci del dizionario. Ritorna le pillole e le parole che restano. */
  function recognise(text, dict) {
    var ws = words(text);
    var taken = new Array(ws.length);
    var found = [];
    var maxLen = 4;

    for (var len = maxLen; len >= 1; len--) {
      for (var i = 0; i + len <= ws.length; i++) {
        var free = true;
        for (var k = i; k < i + len; k++) { if (taken[k]) { free = false; break; } }
        if (!free) continue;
        var slice = ws.slice(i, i + len).join(' ');

        for (var d = 0; d < dict.length; d++) {
          var entry = dict[d];
          var hit = false;
          for (var f = 0; f < entry.forms.length; f++) {
            if (entry.forms[f].length === len && entry.forms[f].join(' ') === slice) { hit = true; break; }
          }
          if (!hit) continue;
          /* una sola pillola per tipo: la prima che si incontra vince */
          if (found.some(function (x) { return x.kind === entry.kind; })) continue;
          for (var m = i; m < i + len; m++) taken[m] = entry.kind;
          found.push({ kind: entry.kind, label: entry.label, values: entry.values, param: entry.param, at: i, len: len });
          break;
        }
      }
    }

    /* rest      = tutto quello che non è diventato pillola
       restNoSize = come il testo digitato, ma senza la taglia: una taglia di una o due lettere
                    come termine di ricerca non aggiunge niente, la trova il filtro */
    var rest = [];
    var restNoSize = [];
    for (var j = 0; j < ws.length; j++) {
      if (!taken[j]) {
        if (FILLER.indexOf(ws[j]) !== -1) continue;
        rest.push(ws[j]); restNoSize.push(ws[j]);
      } else if (taken[j] !== 'size') { restNoSize.push(ws[j]); }
    }
    found.sort(function (a, b) { return a.at - b.at; });
    return { chips: found, rest: rest.join(' '), restNoSize: restNoSize.join(' ') };
  }

  /* Toglie dal testo digitato le parole di una pillola, per la × */
  function stripChip(text, chip) {
    var raw = (text || '').split(/\s+/);
    var ws = words(text);
    if (raw.length !== ws.length) {
      /* se punteggiatura o accenti hanno cambiato il conteggio, lavoro sul testo normalizzato */
      raw = ws;
    }
    raw.splice(chip.at, chip.len);
    return raw.join(' ').replace(/\s+/g, ' ').trim();
  }

  function init(el) {
    if (el.__armoniaSearch) return;
    el.__armoniaSearch = true;

    var form = el.querySelector('[data-armonia-search-form]');
    var input = el.querySelector('input[type="search"]');
    var panel = el.querySelector('[data-armonia-search-panel]');
    var chipsBox = el.querySelector('[data-armonia-search-chips]');
    var chipsList = el.querySelector('[data-armonia-search-chips-list]');
    var results = el.querySelector('[data-armonia-search-results]');
    var allLink = el.querySelector('[data-armonia-search-all]');
    var allText = el.querySelector('[data-armonia-search-all-text]');
    var live = el.querySelector('[data-armonia-search-live]');
    var toggle = el.querySelector('[data-armonia-search-toggle]');
    var header = el.closest('.armonia-header');
    if (!form || !input || !panel || !results) return;

    var uid = (panel.id || 'armonia-search').replace(/-panel$/, '');
    var dict = buildDict(el);
    var minChars = parseInt(el.getAttribute('data-min'), 10) || 3;
    var limit = parseInt(el.getAttribute('data-limit'), 10) || 10;
    var suggestUrl = el.getAttribute('data-suggest-url') || '/search/suggest';
    var searchUrl = el.getAttribute('data-search-url') || '/search';
    var sectionId = el.getAttribute('data-section') || 'armonia-predictive-search';
    var expandable = el.getAttribute('data-expandable') === 'true';
    var tAll = el.getAttribute('data-t-all') || '';
    var tError = el.getAttribute('data-t-error') || '';
    var tChipRemove = el.getAttribute('data-t-chip-remove') || '';
    var tLive = el.getAttribute('data-t-live') || '';

    var controller = null;
    var timer = null;
    var cache = {};
    var stripTerms = el.getAttribute('data-strip') === 'true';
    var state = { chips: [], rest: '', restNoSize: '', index: -1 };

    /* ---------- Apertura / chiusura della barra (solo desktop) ---------- */
    function expand(open) {
      if (!expandable) return;
      el.classList.toggle('is-expanded', open);
      if (header) header.classList.toggle('is-searching', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        input.focus();
      } else {
        closePanel();
      }
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = !el.classList.contains('is-expanded');
        expand(open);
        if (open) track('search_open', { position: 'header' });
      });
    }

    /* ---------- Pannello ---------- */
    /* La classe sull'<html> serve al CSS per far passare la tendina davanti ai banner
       delle app esterne (vedi armonia-header.css). Si toglie appena la tendina si chiude. */
    function openPanel() {
      if (panel.hidden) {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      document.documentElement.classList.add('armonia-searching');
    }

    function closePanel() {
      if (!panel.hidden) {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }
      state.index = -1;
      input.removeAttribute('aria-activedescendant');
      /* Tolgo la classe solo se non è rimasta aperta l'altra tendina (desktop / mobile). */
      if (!document.querySelector('[data-armonia-search-panel]:not([hidden])')) {
        document.documentElement.classList.remove('armonia-searching');
      }
    }

    function rows() {
      return Array.prototype.slice.call(results.querySelectorAll('[data-armonia-search-row]'));
    }

    function highlight(i) {
      var list = rows();
      if (!list.length) return;
      if (i < 0) i = list.length - 1;
      if (i >= list.length) i = 0;
      list.forEach(function (r, k) {
        var on = k === i;
        r.classList.toggle('is-active', on);
        r.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      state.index = i;
      var el2 = list[i];
      if (el2) {
        input.setAttribute('aria-activedescendant', el2.id || '');
        if (el2.scrollIntoView) el2.scrollIntoView({ block: 'nearest' });
      }
    }

    /* ---------- Pillole ---------- */
    function renderChips() {
      if (!chipsList || !chipsBox) return;
      chipsList.textContent = '';
      if (!state.chips.length) { chipsBox.hidden = true; return; }
      chipsBox.hidden = false;

      state.chips.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'armonia-search__chip';
        b.setAttribute('data-kind', c.kind);

        var k = document.createElement('span');
        k.className = 'armonia-search__chip-kind';
        k.textContent = el.getAttribute('data-t-' + c.kind) || c.kind;
        b.appendChild(k);

        var v = document.createElement('span');
        v.className = 'armonia-search__chip-value';
        v.textContent = c.label;
        b.appendChild(v);

        var x = document.createElement('span');
        x.className = 'armonia-search__chip-x';
        x.setAttribute('aria-hidden', 'true');
        x.innerHTML = '<svg width="9" height="9" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" focusable="false"><path d="M2.5 2.5l7 7M9.5 2.5l-7 7"/></svg>';
        b.appendChild(x);

        b.setAttribute('aria-label', tChipRemove.replace('__NAME__', c.label));
        b.addEventListener('click', function () {
          input.value = stripChip(input.value, c);
          input.focus();
          run(true);
        });
        chipsList.appendChild(b);
      });
    }

    /* ---------- Indirizzo della pagina risultati ---------- */
    function resultsHref() {
      /* Di base le parole diventate pillola RESTANO anche nel testo cercato: i filtri si sommano
         al testo, quindi i risultati sono più stretti, e se i filtri non fossero attivi in
         Search & Discovery la ricerca funziona lo stesso. Con «togli dal testo» acceso invece
         restano solo i filtri: più pulito, ma solo se i filtri sono davvero attivi.
         La taglia esce sempre dal testo: una o due lettere non sono un termine di ricerca. */
      var q = stripTerms ? state.rest : state.restNoSize;
      if (!q) {
        q = state.chips
          .filter(function (c) { return c.kind !== 'size'; })
          .map(function (c) { return c.label; })
          .join(' ');
      }
      if (!q) q = norm(input.value);

      var u = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
      state.chips.forEach(function (c) {
        if (!c.param) return;
        /* più valori per lo stesso filtro = OR: copre le grafie diverse nel catalogo */
        c.values.forEach(function (v) {
          u += '&' + encodeURIComponent(c.param) + '=' + encodeURIComponent(v);
        });
      });
      return u;
    }

    function syncAll() {
      if (!allLink) return;
      allLink.href = resultsHref();
      if (allText) allText.textContent = tAll.replace('__TERMS__', input.value.trim());
    }

    /* ---------- Richiesta alla tendina ---------- */
    function fetchPanel(q) {
      var url = suggestUrl +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product' +
        '&resources[limit]=' + limit +
        '&resources[limit_scope]=each' +
        '&section_id=' + encodeURIComponent(sectionId);

      if (cache[url]) { paint(cache[url]); return; }

      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      el.classList.add('is-loading');
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) {
          if (!r.ok) throw new Error('search');
          return r.text();
        })
        .then(function (html) {
          cache[url] = html;
          paint(html);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          el.classList.remove('is-loading');
          results.textContent = '';
          var p = document.createElement('p');
          p.className = 'armonia-search__empty';
          p.textContent = tError;
          results.appendChild(p);
          openPanel();
        });
    }

    function paint(html) {
      el.classList.remove('is-loading');
      /* L'HTML arriva da una sezione NOSTRA (armonia-predictive-search.liquid),
         dove ogni campo passa da escape o money: non è contenuto dell'API incollato grezzo. */
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      var inner = wrap.querySelector('.shopify-section') || wrap;
      results.textContent = '';
      while (inner.firstChild) results.appendChild(inner.firstChild);

      /* Un id per riga, diverso tra tendina desktop e mobile: serve ad aria-activedescendant */
      rows().forEach(function (r, i) { r.id = uid + '-opt-' + (i + 1); });

      state.index = -1;
      input.removeAttribute('aria-activedescendant');
      syncAll();
      openPanel();

      if (live) {
        var n = rows().length;
        live.textContent = tLive.replace('__N__', n);
      }
    }

    /* ---------- Giro completo ---------- */
    function run(immediate) {
      var raw = input.value || '';
      var r = recognise(raw, dict);
      state.chips = r.chips;
      state.rest = r.rest;
      state.restNoSize = r.restNoSize;
      renderChips();

      var q = norm(raw);
      if (q.length < minChars) {
        closePanel();
        results.textContent = '';
        return;
      }
      syncAll();

      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { fetchPanel(q); }, immediate ? 0 : 220);
    }

    input.addEventListener('input', function () { run(false); });

    input.addEventListener('focus', function () {
      if ((input.value || '').trim().length >= minChars && rows().length) openPanel();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        if (panel.hidden) { run(true); return; }
        e.preventDefault();
        highlight(state.index + 1);
      } else if (e.key === 'ArrowUp') {
        if (panel.hidden) return;
        e.preventDefault();
        highlight(state.index - 1);
      } else if (e.key === 'Escape') {
        if (!panel.hidden) { closePanel(); return; }
        if (expandable) expand(false);
      } else if (e.key === 'Enter') {
        var list = rows();
        if (!panel.hidden && state.index >= 0 && list[state.index]) {
          e.preventDefault();
          window.location.href = list[state.index].href;
        }
      }
    });

    form.addEventListener('submit', function (e) {
      if (!(input.value || '').trim()) return;
      e.preventDefault();
      track('search_submit', { terms: input.value.trim(), filters: state.chips.length });
      window.location.href = resultsHref();
    });

    /* clic fuori */
    document.addEventListener('click', function (e) {
      if (el.contains(e.target)) return;
      closePanel();
      if (expandable && !(input.value || '').trim()) expand(false);
    });

    /* Se la pagina è già una ricerca, riempio il campo e ricostruisco le pillole */
    if ((input.value || '').trim()) {
      var r0 = recognise(input.value, dict);
      state.chips = r0.chips;
      state.rest = r0.rest;
      state.restNoSize = r0.restNoSize;
      renderChips();
      syncAll();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-armonia-search]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
